import React, { useState, useEffect } from 'react';
import { updateStream } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const EditStreamModal = ({ stream, onClose, onStreamUpdated }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (stream) {
            setName(stream.name);
        }
    }, [stream]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!name) {
            setError('Name is required.');
            return;
        }

        try {
            await updateStream(stream.id, { name });
            onStreamUpdated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Edit Stream</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Name'
                        />
                    </div>
                    <div className='actions-centered'>
                        <button type="submit" className="submit-button text-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditStreamModal;